<template>
  <div>
    <input
      type="file"
      accept="text/csv,application/msexcel"
      @change="onChange"
      class="w-full"
    />
    <div class="flex items-center justify-end pt-4 border-t">
      <button
        class="py-2 px-4 border border-gray-600 hover:bg-indigo-600 hover:text-white hover:border-transparent rounded focus:outline-none"
        @click="submit"
      >
        Importar
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import axios from "axios";
import { read, utils } from "xlsx";

export default {
  props: {
    entry: {
      type: Object,
    },
    import: {
      type: String,
    },
  },
  data() {
    return {
      rows: null,
    };
  },
  computed: {
    ...mapState(["tabs", "user"]),
    ...mapGetters(["currentTab"]),
  },
  methods: {
    ...mapMutations(["hideModal"]),
    ...mapActions(["selectTab"]),
    onChange(ev) {
      const file = ev.target.files[0];

      const reader = new FileReader();

      reader.addEventListener("load", (event) => {
        const data = new Uint8Array(event.target.result);

        const workbook = read(data, { type: "array", codepage: 65001 });
        const sheets = workbook.SheetNames;

        this.rows = sheets.reduce((acc, val) => {
          const sheetPage = utils.sheet_to_json(workbook.Sheets[val]);
          sheetPage.forEach((row) => {
            acc.push(row);
          });

          return acc;
        }, []);
      });

      reader.readAsArrayBuffer(file);
    },
    submit() {
      const data = this.rows.map((row) => {
        switch (this.import) {
          case "teachers":
            return {
              ...row,
              colegio: this.user.colegio,
              ID_Location: this.entry.ID_Location,
            };
          case "students":
            if (this.entry.ID_Curso) {
              return {
                ...row,
                colegio: this.user.colegio,
                ID_Location: this.entry.ID_Location,
                ID_Curso: this.entry.ID_Curso,
              };
            } else {
              return {
                ...row,
                colegio: this.user.colegio,
                ID_Location: this.entry.ID_Location,
              };
            }
          case "disciplines":
            if (this.entry.ID_Curso) {
              return {
                ...row,
                ID_Curso: this.entry.ID_Curso,
                colegio: this.user.colegio,
              };
            } else {
              return {
                ...row,
                colegio: this.user.colegio,
              };
            }
        }
      });

      let action;
      switch (this.import) {
        case "teachers":
          action = "importTeachers";
          break;
        case "students":
          action = "importStudents";
          break;
        case "disciplines":
          action = "importDisciplines";
          break;
      }

      axios
        .post("server/index.php", {
          action,
          user: this.user.num,
          colegio: this.user.colegio,
          data,
        })
        .then(() => {
          const importTab = this.tabs.find((tab) => tab.type === this.import);
          this.hideModal();
          this.selectTab(importTab);
        });
    },
  },
};
</script>
